import { EventSystemUser } from "../../enums/event-system-user.enum";
import { EventType } from "../../enums/event-type.enum";

export class EventView {
  message: string;
  humanReadableMessage: string;
  appIcon: string;
  appName: string;
  userId: string;
  // The acting user id from the event (not coalesced with the subject/creator). Send access
  // events use this to tell a member accessor apart from an external one.
  actingUserId: string;
  userName: string;
  userEmail: string;
  date: string;
  ip: string;
  type: EventType;
  installationId: string;
  systemUser: EventSystemUser;
  serviceAccountId: string;

  constructor(data: Required<EventView>) {
    this.message = data.message;
    this.humanReadableMessage = data.humanReadableMessage;
    this.appIcon = data.appIcon;
    this.appName = data.appName;
    this.userId = data.userId;
    this.actingUserId = data.actingUserId;
    this.userName = data.userName;
    this.userEmail = data.userEmail;
    this.date = data.date;
    this.ip = data.ip;
    this.type = data.type;
    this.installationId = data.installationId;
    this.systemUser = data.systemUser;
    this.serviceAccountId = data.serviceAccountId;
  }
}
